const LOAD_DATA_GALLERY           = 'LOAD_DATA_GALLERY'
const LOAD_DATA_GALLERY_SUCCESS   = 'LOAD_DATA_GALLERY_SUCCESS'
const LOAD_DATA_GALLERY_FAILED    = 'LOAD_DATA_GALLERY_FAILED'
const UNMOUNT_DATA_GALLERY        = 'UNMOUNT_DATA_GALLERY'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const galleryReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_GALLERY:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_GALLERY_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_GALLERY_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_GALLERY:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default galleryReducer;